import {Injectable} from '@angular/core';
import {DefaultService} from '@common/references/default.service';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import urlJoin from 'url-join';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: "root",
})

export class ContractsService extends DefaultService<any> {
  backendName = 'rental-contracts';
  formModalOptions: NgbModalOptions = {
    size: "xl",
  }

  hasActions = false;
  hasAdd = false;
  hasEdit = false;
  hasDelete = false;
  hasView = false;

  getUrl(): string {
    return urlJoin(environment.apiUrl, '/rental-contracts');
  }
}
